export const SET_GLOBAL_STATS_DATA = "SET_GLOBAL_STATS_DATA"
export const SET_MY_STATS_DATA = "SET_MY_STATS_DATA"
export const SET_STATS_INDEX = "SET_STATS_INDEX"
